<div class="preview-main-wrapper" *ngIf="data">
    <div class="preview-wrapper">
        <div class="preview-header" [ngStyle]="{'background-color': data.colors.primary_color}">
            <h5 [ngStyle]="{'color': data.colors.text_color}">{{data.headings.main}}</h5>
            <p [ngStyle]="{'color': data.colors.text_color}">{{data.headings.meta}}</p>
            <a *ngIf="data.cta.show" [href]="functionService.forceUrl(data.cta.url)" target="_blank" class="btn mt-4"
                [ngStyle]="{'background-color': data.colors.secondary_color, 'color': data.colors.text_color}">
                {{data.cta.title === 'Custom' ? data.cta.custom_title : data.cta.title}}
            </a>
        </div>
        <div class="preview-body">
            <div class="preview-imgs" itemscope itemtype="http://schema.org/ImageGallery"
                [class.grid]="data.images.grid && data.images.list.length > 1">
                <ng-container *ngIf="data.images.grid; else notGrid">
                    <ng-container *ngFor="let image of images; let i = index">
                        <ng-container *ngIf="i%2===0">
                            <ng-template *ngTemplateOutlet="showGalleryItem; context: {image}"></ng-template>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngFor="let image of images; let i = index">
                        <ng-container *ngIf="i%2===1">
                            <ng-template *ngTemplateOutlet="showGalleryItem; context: {image}"></ng-template>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-template #notGrid>
                    <ng-container *ngFor="let image of images; let i = index">
                        <ng-template *ngTemplateOutlet="showGalleryItem; context: {image}"></ng-template>
                    </ng-container>
                </ng-template>

                <ng-template #showGalleryItem let-image="image">
                    <figure itemprop="associatedMedia" (click)="openGallery(image, $event)" itemscope
                        itemtype="http://schema.org/ImageObject">
                        <a [href]="image.url" itemprop="contentUrl">
                            <img loading="lazy" [src]="image.url" itemprop="thumbnail" [alt]="image.name">
                        </a>
                        <!-- <figcaption itemprop="caption description">Image caption  1</figcaption> -->
                    </figure>
                </ng-template>

            </div>

            <div *ngIf="loading" class="preview-placeholders"
                [class.grid]="data.images.grid && data.images.list.length > 1">
                <p class="placeholder-glow w-45" *ngFor="let _ of data.images.grid ? [1,2,3,4]: [1]">
                    <span class="placeholder col-12"></span>
                </p>
            </div>
        </div>

        <div class="text-center mt-3">
            <a [href]="functionService.forceUrl(data.website)" target="_blank"
                [ngStyle]="{'color': data.colors.secondary_color}">{{data.website}}</a>
        </div>
    </div>
    <div class="d-flex flex-column bd-highlight sticky-footer-container">

        <div class="mb-2" id="back-to-top" (click)="functionService.scrollToTop('.preview-main-wrapper')">
            <div class="share-button" [ngStyle]="{'background-color': data.colors.secondary_color}"
                data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="left" title="Back to top">
                <i class="bi bi-chevron-up" [ngStyle]="{'color': data.colors.text_color}"></i>
            </div>
        </div>

        <div class="mb-2" *ngIf="data.show_qr_code">
            <div class="share-button" data-bs-custom-class="qr-preview-tooltip"
                [ngStyle]="{'background-color': data.colors.secondary_color}" data-bs-toggle="tooltip"
                data-bs-trigger="hover focus" data-bs-placement="left" data-bs-html="true"
                title="<img src='{{qr_url}}' class='rounded' height='170' width='170'>">
                <i class="bi bi-qr-code-scan" [ngStyle]="{'color': data.colors.text_color}"></i>
            </div>
        </div>
        <div class="mb-2" *ngIf="data.share_on">
            <div class="share-button" [ngStyle]="{'background-color': data.colors.secondary_color}">
                <app-share-to-social [data]="social_data" [text_color]="data.colors.text_color"></app-share-to-social>
            </div>
        </div>
    </div>
</div>




<!-- Root element of PhotoSwipe. Must have class pswp. -->
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

    <!-- Background of PhotoSwipe. 
         It's a separate element, as animating opacity is faster than rgba(). -->
    <div class="pswp__bg"></div>

    <!-- Slides wrapper with overflow:hidden. -->
    <div class="pswp__scroll-wrap">

        <!-- Container that holds slides. PhotoSwipe keeps only 3 slides in DOM to save memory. -->
        <!-- don't modify these 3 pswp__item elements, data is added later on. -->
        <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">

            <div class="pswp__top-bar">

                <!--  Controls are self-explanatory. Order can be changed. -->

                <div class="pswp__counter"></div>

                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                <button class="pswp__button pswp__button--share" title="Share"></button>

                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                <!-- element will get class pswp__preloader--active when preloader is running -->
                <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                        <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                <div class="pswp__share-tooltip"></div>
            </div>

            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
            </button>

            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
            </button>

            <div class="pswp__caption">
                <div class="pswp__caption__center text-center"></div>
            </div>

        </div>

    </div>

</div>